import { translations } from "../../translations"
import { useTranslationUpdate } from "../../hooks/useTranslationUpdate"
import styles from "./GalleryWindow.module.css"

type Props = {
  title: string
  onBack?: () => void
}

export default function GalleryHeader({ title, onBack }: Props) {
  useTranslationUpdate()
  return (
    <div className={styles.header}>
      <div>
        {onBack && (
          <button className={styles.backBtn} onClick={onBack} aria-label="Voltar">
            <svg width="10" height="16" viewBox="0 0 10 16" fill="none">
              <path 
                d="M8.5 1L1.5 8L8.5 15" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
            <span>{translations("gallery.albums")}</span>
          </button>
        )}
      </div>
      <div className={styles.headerTitle}>{title}</div>
      <div className={styles.headerRight} />
    </div>
  )
}
